module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1364db7a0b3dfd6629ffc48f00a4f2d2.png";